import React, { useState, useEffect } from "react";
import HowNearMeDumpster from "../components/how-nearme-dumpster";
import { GET_PROS_NEARME } from '../components/nearmeQueryDefinition'
import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client'
import ProCardsNearMe from "../components/pro-card-nearme";
import PopularArticlesNearMe from "../components/popular-articles-nearme";
import LayoutDumpster from "../components/layout-dumpster";
import ZipFinderNearme from "../components/zip-finder-nearme";

const defaultOptions = {
    watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore',
    },
    query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
    },
}

const NEARMEPAGEDUMPSTER = (props) => {
    const project_type = props.pageContext.project_type;
    const env = props.pageContext.env
    const code = props.pageContext.code
    const project_types = props.pageContext.project_types
    const popular_articles = props.pageContext.articles
    const video = code === 'junk-removal' ? 'https://www.youtube-nocookie.com/embed/WmTIK_sX0S8' : ( code === 'comercial-trash-service' ? 'https://www.youtube-nocookie.com/embed/6bqFwoXxLyQ' : 'https://www.youtube-nocookie.com/embed/0QgduQnNCMM' );
    const text = project_type.subtitle ? project_type.subtitle : (code === 'junk-removal' ? 'Find the top junk removal companies serving your hometown' : (code === 'comercial-trash-service' ? 'Find the top commercial waste services near you' : 'Find the top dumpster rental services near you'));
    const online_booking_pros = props.pageContext.enabledBooking || [];

    const seo =
    {
        url: `near-me/${project_type.name.replace(/\s/g, '-').toLowerCase()}`,
        env: env,
        code: code,
        page: 'nearme',
        title: project_type.title ? project_type.title : project_type.name + " Near Me",
        description: text + ". Save time by getting fast quotes from top-rated local companies.",
        image: "/images/backgrounds/project-types/" + project_type.name.replace(/\s/g, "-") + ".webp"
    }

    const [zipCode, setZipCode] = useState(null);
    const [title, setTitle] = useState(project_type.title ? project_type.title : project_type.name + " Near Me");
    const [prosList, setProsList] = useState([]);
    const [placeName, setPlaceName] = useState('')
    const [changeZip, setChangeZip] = useState('')
    const [error, setError] = useState('')
    const [kppUrl, setKppUrl] = useState(null)
    const [kppText, setKppText] = useState(null)
    const [sponsoredPros, setSponsoredPros] = useState([]);

    const faq = project_type.faq?.value;

    const headers = {};
    headers['Ocp-Apim-Subscription-Key'] = process.env.GATSBY_API_MANAGMENT_KEY;

    const client = new ApolloClient({
        link: new HttpLink({ uri: `${process.env.GATSBY_BOOKABLE_SEARCH_API}`,headers: headers}),
        cache: new InMemoryCache(),
        defaultOptions: defaultOptions
    })

    const makeNearmeProsQuery = (zipcode, projectType) => {
        let vars = {
            page: 1,
            limit: 10,
            zipcode,
            projectType,
            site: env.site
        }
        client.query({
            query: GET_PROS_NEARME,
            variables: vars
        }).then(result => {
            if (result.data.nearmeDefinition) {
                setProsList(result.data.nearmeDefinition.posts)
                setSponsoredPros(result.data.nearmeDefinition.sponsoredPros);
                if (!zipCode) {
                    setZipCode(result.data.nearmeDefinition.zipcode)
                }
                //Remove Near You / in your area 
                if (result.data.nearmeDefinition.place) {
                    let newTitle
                    newTitle = title.replace("Near You", "");
                    newTitle = newTitle.replace("in Your Area", "");
                    newTitle = newTitle.replace("Near Me", "");
                    setTitle(newTitle.split(' in ')[0] + " in " + result.data.nearmeDefinition.place);
                    setPlaceName(result.data.nearmeDefinition.place)
                }
                getKppUrl(zipCode ? zipCode : result.data.nearmeDefinition.zipcode, result.data.nearmeDefinition.place);
            }
        })
    }

    useEffect(async () => {
        //get query params and check if zip code exists
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });
        let obtainedCode = params.zip_code;
        if (obtainedCode) {
            setZipCode(obtainedCode);
        } else {
            makeNearmeProsQuery(
                null,
                project_type.drupal_internal__id.toString()
            );
        }
    }, []);

    useEffect(() => {
        if (zipCode) {
            makeNearmeProsQuery(
                zipCode.length === 5 ? zipCode : '0' + zipCode,
                project_type.drupal_internal__id.toString()
            );
        }
    }, [zipCode]);

    const handleClick = (e) => {
        e.preventDefault();
        if (/^[0-9]*$/.test(changeZip) && changeZip.length === 5) {
            setZipCode(changeZip);
            setChangeZip('');
            setError('')
            document.getElementById('dropdownLocation').classList.remove('show')
        } else setError('Must be a 5 digit number')
    }

    const getKppUrl = (zip, namePlace) => {
        const auxCode = code === 'home' ? 'dumpster' : code;
        const endpoint = '/api/v1/kpp/service_types/' + auxCode + '/zip_codes/' + zip;
        const url = `${process.env.GATSBY_DRUPAL_URL}` + endpoint;
        const headers = {};
        headers['Ocp-Apim-Subscription-Key'] = process.env.GATSBY_API_MANAGMENT_KEY;
        fetch(url,
            {
                method: 'get',
                headers: headers
            })
            .then(res => res.json())
            .then((response) => {
                if (Array.isArray(response)) {
                    setKppUrl(null);
                    return null;
                }
                setKppUrl("/" + response);
                setKppText("View All Pros in " + namePlace);
            })
            .catch((error) => {
                console.log(error);
            })
    }

    return (
        <LayoutDumpster seo={seo} footerColor='white' env={env} code={code} bgcolor='#f5f5f5'>
            <ZipFinderNearme
                id='home-zip-code'
                code={code}
                title={title}
                text={text}
                button="Find Pros"
                bottomtext="America's #1 Source for Dumpsters and Junk Removal"
                env={env}
                backgroundClass={"bk-" + project_type.name.replace(/\s/g, "-").replace(/,/g, "")}
            />

            <HowNearMeDumpster 
                title={code === 'dumpster' && 'The Best Way to Book a Dumpster'}
                book={code === 'dumpster'}
            />

            <div className="blog">
                <div className="container mb-5">
                    <div className="cardsTitle">
                        {project_type.name} Services in Your Area
                    </div>
                    <div className="col-lg-8" style={{ marginBottom: '5rem' }}>
                        <div className="nav-item dropdown">
                            <a className='nav-link dropdown-toggle dropContainer' data-toggle='dropdown' role="button" data-target="dropdown-menu" aria-expanded="false" onClick={() => { document.getElementById('dropdownLocation').classList.toggle('show') }}><span className="location-icon" /> {placeName ? placeName : 'Filter by Zip Code'}</a>
                            <div id="dropdownLocation" className="dropdown-menu dropdown-menu-right dropMenuContainer">
                                <p>Filter by Zip Code</p>
                                <div>
                                    <input maxlength="5" type='text' className="form-control" name="location" value={changeZip} placeholder='Enter Zip Code' onChange={(e) => setChangeZip(e.target.value)} />
                                    <button className="btn btn-primary" onClick={handleClick}>Filter</button>
                                </div>
                                <p>{error}</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-8">
                            {!placeName ?
                                <h2 className="errormsg">No location found.  Please enter your zip code to find service pros in your area.</h2>
                                : placeName && prosList?.length === 0 ?
                                <h2 className="errormsg">We’re sorry.  There aren’t any service pros for your area.</h2>
                                : (
                                <>
                                    {sponsoredPros?.length > 0 &&
                                    <div style={{ marginBottom: '50px' }}>
                                        <h2 className="cardListTitle">Sponsored results</h2>
                                        {sponsoredPros.map(pro => {
                                            return (
                                                <ProCardsNearMe cardClass="sponsoredProCardNearMe" code={code} proData={pro} online_booking_pros={online_booking_pros}></ProCardsNearMe>
                                            )
                                        })}
                                    </div>
                                    }
                                    <div>
                                        <h2 className="cardListTitle">{`All "${project_type.name}" results near me in ${placeName} - ${new Date().toLocaleString('en-US', { month: 'long', year: 'numeric' })}`}</h2>
                                        {prosList?.map(pro => {
                                            return (
                                                <ProCardsNearMe code={code} proData={pro} online_booking_pros={online_booking_pros}></ProCardsNearMe>
                                            )
                                        })}
                                    </div>
                                </>
                                )
                            }
                            {kppUrl && <a className="readMore" href={kppUrl}>{kppText}</a>}
                            <div className="cardsTitle">
                                Related Articles
                            </div>
                            <div>
                                {popular_articles?.map((art, index) => {
                                    return (
                                        <PopularArticlesNearMe blogInfo={art}></PopularArticlesNearMe>
                                    )
                                })}
                            </div>
                            <a className="readMore" href={"/blog/tags/" + project_type.name.replace(/\s/g, "-").replace(/,/g,'')}>{"Read More: " + project_type.name}</a>
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar no-margin">
                                <div class="howvideo services mb-5">
                                    <div className="card">
                                        <iframe style={{ marginBottom: "0px" }} src={video} width="560" height="315" frameborder="0" loading="lazy"></iframe>
                                    </div>
                                </div>

                                <div className="block">
                                    <div style={{ marginBottom: "20px", backgroundColor: "#E7E7E7", padding: "26px", fontWeight: "bold", fontSize: "30px" }}>Other Pros Near You</div>
                                    {project_types?.map((pt, index) => {
                                        return (
                                            <a key={index} style={{ color: "#4D7DEB", textDecoration: "none", fontWeight: "bold", fontSize: "20px", paddingLeft: "26px", marginBottom: "8px" }} href={"/near-me/" + pt.name.replace(/\s/g, "-").replace(/,/g,'').toLowerCase() + "?zip_code=" + zipCode}>{pt.name}</a>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bottomSection">
                <div className="container mb-5">
                    {faq && <div className="row" style={{ backgroundColor: "white", marginBottom: "5rem" }}>
                        <div className="faq" dangerouslySetInnerHTML={{ __html: faq }}></div>
                    </div>
                    }
                </div>
            </div>


        </LayoutDumpster>
    )
}

export default NEARMEPAGEDUMPSTER;